export enum GradeSyncJobStatus {
  pending = 0,
  running = 1,
  completed = 2,
  failed = 3,
  continuing = 4,
}
